import styled from "styled-components";
import AudienceBackground from '../../assets/images/audience-bg.jpg';

export const Page = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: var(--font-gotham);
    background-image: url(${AudienceBackground});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: rgb(250, 235, 184);
    .mrBottomExtraLarge {
        margin-bottom: ${ props => props.theme.spacing.extraLarge };
    }
    .mrBottomLarge {
        margin-bottom: ${ props => props.theme.spacing.large };
    }
    
    .mrBottomMain {
        margin-bottom: ${ props => props.theme.spacing.main };
    }

    .mrBottomSmall {
        margin-bottom: ${ props => props.theme.spacing.small };
    }
    .mrBottom100 {
        margin-bottom: 100px;
    }

    .desktopLogo {
        position: absolute;
        top: ${ props => props.theme.spacing.main };
        left: ${ props => props.theme.spacing.main };
        width: 274px;
        height: auto;
    }
`;